import React from "react";
import ReactDOM from "react-dom";
import {
  useAsyncDebounce
} from "react-table";
import { Adalicon } from "../Icons.jsx";

// Define a default UI for filtering
const GlobalFilter = ({ globalFilter, setGlobalFilter, ...rest }) => {
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <div className={`react-table-search pull-right ${rest.containerClass || ''}`}>
      <input
        type="search"
        className={`form-control input-sm ${rest.inputClass || ''}`}
        style={rest.inputStyle}
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        autoComplete={false}
      />
      <Adalicon type="search" className="search-icon" />
    </div>
  );
};

// Use portal, so search field don't have to be inside the table
export const GlobalFilterPortal = ({ searchContainerRef, ...rest }) => {
  return ReactDOM.createPortal(<GlobalFilter {...rest} />, searchContainerRef.current);
};

export default GlobalFilter;